import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import PongAgeCounter from "../components/PongAgeCounter";

const AboutPage = () => {
  const { t } = useTranslation();

  const creators = [
    {
      name: "mmarek",
      img: "/images/pong_cat1.gif",
      bio: t('about_creator_mmarek_bio'),
    },
    {
      name: "yalechin",
      img: "/images/pong_cat2.gif",
      bio: t('about_creator_yalechin_bio'),
    },
    {
      name: "lnikolov",
      img: "/images/pong_cat3.gif",
      bio: t('about_creator_lnikolov_bio'),
    },
    {
      name: "akretov",
      img: "/images/pong_cat4.gif",
      bio: t('about_creator_akretov_bio'),
    },
    {
      name: "fhauba",
      img: "/images/pong_cat5.gif",
      bio: t('about_creator_fhauba_bio'),
    },
  ];

  const timeline = [
    {
      year: "1972",
      text: t('about_historyTimeline1972'),
    },
    {
      year: "1973",
      text: t('about_historyTimeline1973'),
    },
    {
      year: "2026",
      text: t('about_historyTimeline2026'),
    },
  ];
  return (
    <div className="min-h-[calc(100vh-64px)] px-4 py-12">
      <div className="max-w-2xl mx-auto space-y-16">
        {/* Hero */}
        <div className="text-center space-y-4">
          <span className="text-xs font-mono uppercase tracking-widest text-violet-400">
            {t('about_tag')}
          </span>
          <h1 className="text-4xl sm:text-5xl font-black text-white tracking-tight">
            {t('about_title')}
          </h1>
          <p className="text-zinc-400 text-base leading-relaxed">
            {t('about_subtitle')}
          </p>
        </div>

        {/* Image */}
        <img
          src="/images/first_pong.png"
          alt="Original Pong Arcade Game"
          className="w-full max-w-md mx-auto rounded-xl border border-white/8 shadow-2xl"
        />

        {/* Timeline */}
        <section>
          <h2 className="text-xl font-bold text-white mb-6">{t('about_historyHeading')}</h2>
          <div className="relative pl-6 border-l border-white/10 space-y-8">
            {timeline.map(({ year, text }) => (
              <div key={year} className="relative">
                <span className="absolute -left-[25px] top-1 w-3 h-3 rounded-full bg-violet-500 border-2 border-[oklch(0.085_0.015_270)]" />
                <p className="text-zinc-400 text-sm leading-relaxed">
                  <strong className="text-white">{year}:</strong> {text}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* GIF + age counter */}
        <div className="text-center space-y-4">
          <img
            src="/images/pong_gif.gif"
            alt="Pong Animation"
            className="w-full max-w-sm mx-auto rounded-xl border border-white/8"
          />
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl border border-violet-500/30 bg-violet-500/5 text-sm text-zinc-300">
            <span className="text-violet-400 font-bold text-lg">
              <PongAgeCounter />
            </span>
            {t('about_pongAgeCounter')}
          </div>
        </div>

        {/* Impact */}
        <section className="space-y-3">
          <h2 className="text-xl font-bold text-white">{t('about_impactHeading')}</h2>
          <p className="text-zinc-400 text-sm leading-relaxed">
            {t('about_impactText1')}
          </p>
          <p className="text-zinc-400 text-sm leading-relaxed">
            {t('about_impactText2')}
          </p>
        </section>

        {/* Facts */}
        <section className="space-y-3">
          <h2 className="text-xl font-bold text-white">{t('about_factsHeading')}</h2>
          <p className="text-zinc-400 text-sm leading-relaxed">
            {t('about_factsText1')}
          </p>
          <p className="text-zinc-400 text-sm leading-relaxed">
            {t('about_factsText2')}
          </p>
        </section>

        {/* About this project */}
        <section className="space-y-3">
          <h2 className="text-xl font-bold text-white">{t('about_projectHeading')}</h2>
          <p className="text-zinc-400 text-sm leading-relaxed">
            {t('about_projectText')}
          </p>
        </section>

        {/* Creators */}
        <section>
          <h2 className="text-xl font-bold text-white mb-6 text-center">
            {t('about_creatorsHeading')}
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {creators.map(({ name, img, bio }) => (
              <div
                key={name}
                className="flex flex-col items-center text-center p-5 rounded-xl border border-white/8 bg-white/2 hover:bg-white/4 transition-colors"
              >
                <img
                  src={img}
                  alt={name}
                  className="w-16 h-16 rounded-full object-cover border-2 border-violet-500/40 mb-3"
                />
                <h3 className="text-sm font-semibold text-white mb-1">
                  {name}
                </h3>
                <p className="text-xs text-zinc-500 leading-relaxed">{bio}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Back */}
        <div className="text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-white transition-colors"
          >
            {t('about_backToHome')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
